import * as Sentry from "@sentry/react";

const sendExceptionToSentry = (error) => {
    Sentry.captureException(error);
}

export default sendExceptionToSentry;
